interface Compliance {
  compliance?: SubCompliance;
  compliance_code: string;
  mwaste_id: number;
}

interface PharmaCompliance {
  compliance: SubCompliance | null;
  compliance_code: string;
  container_id: number;
}

interface MwasteCompliance {
  compliance: SubCompliance | null
  compliance_code: string
  mwaste_id: number
}

interface AmalgamCompliance {
  compliance?: SubCompliance
  compliance_code: string
  container_id: number
}

interface Item {
  category: string;
  images: string;
  is_backordered: boolean;
  is_controlled_substance: boolean;
  is_discontinued: boolean;
  is_refillable: boolean;
  is_sds: boolean;
  item_number: string;
  manufacturer_name: string;
  name: string;
  price: number;
  subcategory: string;
  type: string;
}

interface SubCompliance {
  category: string;
  compliance_code: string;
  compliance_status: number;
  message_long: string;
  message_short: string;
  priority: number;
}

export interface PracticePharmaCompliance {
  compliance: SubCompliance;
  customer_number: string;
  compliance_code: string;
}

export interface AmalgamWasteItem {
  active: boolean;
  amalgam_compliance: AmalgamCompliance;
  container_id: number;
  customer_number: string;
  dealer: string | null;
  destroyed_weight: number;
  disposal_status?: number;
  item?: Item;
  item_number: string;
  processed_date: string;
  received_date: string;
  serial_number: string;
  shipped_date: string;
  status: number;
  used_date: string | null;
  isRenewal?: boolean;
}

export interface PracticeMwasteCompliance {
  compliance: SubCompliance
  compliance_code: string
  customer_number: string
}

export interface MedicalWasteResponse {
  mwaste_containers: MedicalWasteItem[]
  practice_mwaste_compliance: PracticeMwasteCompliance | null
}

export interface PracticeAmalgamCompliance {
  compliance: SubCompliance
  compliance_code: string
  customer_number: string
}

export interface AmalgamWasteResponse {
  amalgam_containers: AmalgamWasteItem[]
  practice_amalgam_compliance: PracticeAmalgamCompliance
}

export interface MedicalWasteItem {
  active: boolean;
  mwaste_compliance: MwasteCompliance | null;
  customer_number: string;
  destroyed_date: string;
  destroyed_weight: number;
  disposal_status: number;
  item: Item | null;
  item_number: string;
  mwaste_id: number;
  received_date: string;
  serial_number: string;
  shipped_date: string;
  status: number;
  treatment_type: string;
  used_date: string | null;
  vendor: string | null;
  vendor_id: number;
  isRenewal?: boolean;
}

export interface PharmaceuticalWasteItem {
  pharma_compliance?: PharmaCompliance | null;
  container_id: number;
  customer_number: string;
  disposal_status?: number;
  item?: Item | null;
  item_number: string;
  processed_date: string;
  processed_weight: number;
  received_date: string;
  serial_number: string;
  shipped_date: string;
  status: number;
  used_date: string | null;
  vendor: string;
  isRenewal?: boolean;
}

export interface WasteManagementProcessor {
  name: string;
  street: string;
  city: string;
  state: string;
  zip: string;
  facilityPermit: string;
  processingRep?: string;
  signatureImage?: string;
}

export enum WasteStatus {
  inUse = 0,
  destroyed = 1,
  used = 2
}

export interface PharmaceuticalWasteItemResponse {
  pharma_containers: PharmaceuticalWasteItem[]
  practice_pharma_compliance: PracticePharmaCompliance
}